module.exports = (object, contentType) => {

  const data = (() => {

    // { k1: [v1, v2], k2: [v1 , v2], ... } (multipart/form-data)
    if(contentType && contentType.match(/multipart\/form-data/)){

      return Object.values(
        Object.entries(object).reduce((o, [k, v]) => {

          return ((!Array.isArray(v)) ? [v] : v).reduce((o, v, i) => {
            return {...o, [i]: {...o[i], [k]: v}};
          }, o);

        }, {})
      );

    }

    // {}
    if(Object.keys(object).filter(v => isNaN(v)).length){
      return [object];
    }

    //[ {}, {}, ... ] : [ [], [], ... ]
    const [header, ...body] = Object.values(object);

    return (!Array.isArray(header)) ? [header, ...body] : body.map((v) => {
      return v.reduce((o, v, i) => ({...o, [header[i]]: (isNaN(v)) ? v : Number(v)}), {});
    });

  })();

  return data;
};
